// @ts-nocheck
import * as React from "react";

const CheckmarkCircle: React.FC = () => {
    return (
        <svg width="24px" height="24px" viewBox="0 0 24 24">
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <polygon opacity="0" fillRule="nonzero" points="0 0 24 0 24 24 0 24"></polygon>
                <path
                    d="M11.9999996,2 L11.9999996,2 C6.47714956,2 1.99999956,6.47715 1.99999956,12 C1.99999956,17.52285 6.47714956,22 11.9999996,22 C17.5228496,22 21.9999996,17.52285 21.9999996,12 L21.9999996,12 C21.9999996,6.47715044 17.5228496,2 11.9999996,2 L11.9999996,2 Z M16.3,9.61 L11.73,15.61 L11.73,15.61 C11.541207,15.855247 11.249497,15.999256 10.94,16.0000145 L10.94,16.0000145 C10.63222,16.001658 10.340822,15.861492 10.15,15.62 L7.71000004,12.51 L7.70999995,12.5099999 C7.37034495,12.0736949 7.44869495,11.4446599 7.88499995,11.1049999 C8.32130495,10.7653449 8.95033995,10.8436949 9.28999995,11.2799999 L10.92,13.3599999 L14.7,8.35999989 L14.6999999,8.35999993 C15.0368939,7.91817193 15.6681719,7.83310593 16.1099999,8.16999993 C16.5518279,8.50689393 16.6368939,9.13817193 16.2999999,9.57999993 C16.2999999,9.57999993 16.2999999,9.57999995 16.2999999,9.57999995 L16.3,9.61 Z"
                    fill="currentColor"
                ></path>
            </g>
        </svg>
    );
};

export default React.memo(CheckmarkCircle);
